// extracted by mini-css-extract-plugin
module.exports = {"container":"e_HI","readReviewButton":"e_II","arrowRight":"e_JI","imageContainer":"e_KI","image":"e_LI","badge":"e_MI","badgeImage":"e_NI","content":"e_OI","title":"e_PI"};